import React from "react";

import { TaskField } from "../../smart/camunda/forms/padrao/taskField";

function GetContent(props) {
  const item = props.item;

  function eventHandle(key, value, camundaValue) {
    const { form, updateForm } = props;

    const type = "String";

    updateForm({
      ...form,
      values: {
        ...(form && form.values && form.values),
        [key]: value,
      },
      camundaValues: {
        ...(form && form && form.camundaValues && form.camundaValues),
        [key]: camundaValue || { type, value, valueInfo: {} },
      },
    });
  }

  if (item) {
    return (
      <TaskField
        attributes={item}
        fieldProperties={item}
        {...item}
        isPreview={true}
        onChange={eventHandle}
      />
    );
  }
}

export default GetContent;
